'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var reactPlaidLink = require('react-plaid-link');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var PlaidDecorator = function PlaidDecorator(_ref) {
  var env = _ref.env,
      publicKey = _ref.publicKey,
      clientName = _ref.clientName,
      product = _ref.product,
      onSuccess = _ref.onSuccess,
      className = _ref.className,
      style = _ref.style,
      selectAccount = _ref.selectAccount,
      topLevelChildren = _ref.children,
      rest = _objectWithoutProperties(_ref, ["env", "publicKey", "clientName", "product", "onSuccess", "className", "style", "selectAccount", "children"]);

  return React__default['default'].cloneElement(topLevelChildren, {
    PlaidLink: function PlaidLink(_ref2) {
      var children = _ref2.children;
      return /*#__PURE__*/React__default['default'].createElement(reactPlaidLink.PlaidLink, _extends({
        env: env,
        publicKey: publicKey,
        clientName: clientName,
        product: product,
        onSuccess: onSuccess,
        style: style,
        selectAccount: selectAccount,
        className: className
      }, rest), children);
    }
  });
};
PlaidDecorator.defaultProps = {
  children: function children() {},
  product: ['auth'],
  onSuccess: function onSuccess() {},
  style: {},
  className: null,
  selectAccount: true
};
PlaidDecorator.propTypes = {
  env: PropTypes__default['default'].string.isRequired,
  publicKey: PropTypes__default['default'].string.isRequired,
  clientName: PropTypes__default['default'].string.isRequired,
  product: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
  onSuccess: PropTypes__default['default'].func,
  style: PropTypes__default['default'].object,
  className: PropTypes__default['default'].string,
  selectAccount: PropTypes__default['default'].bool
};

module.exports = PlaidDecorator;
